import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as AuthActions from 'libs/shared/data/stores/auth/auth.actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';

import { ChatService } from '@offconon/core-api';

import { ChatChannelListActions } from './chat-channel-list.actions';

@Injectable()
export class ChatChannelListEffects {
  private actions$ = inject(Actions);
  private chatService = inject(ChatService);
  private store$ = inject(Store);

  updateChatSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChatChannelListActions.updateChatSettings),
      mergeMap(({ settings }) =>
        this.chatService.chatChatSettingsPartialUpdate(settings).pipe(
          tap((settings) => this.store$.dispatch(AuthActions.setChatSettings({ settings }))),
          map((settings) => ChatChannelListActions.updateChatSettingsSuccess({ settings })),
          catchError((error) =>
            of(ChatChannelListActions.updateChatSettingsFailure({ error: error.message })),
          ),
        ),
      ),
    );
  });
}
